import React from "react";
import ReactModal from "react-modal";

const ModalError = ({
  isOpen,
  onOk,
  onCancel,
  message,
  textOk = "Submit",
  textCancel = "Cancel",
  description = "",
  loading = false,
  children,
  width = undefined,
  zIndex = "9999"
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onCancel}
      ariaHideApp={false}
      className="custom-modal"
      style={{
        overlay: {
          zIndex: zIndex,
        },
      }}
    >
      <button
        type="button"
        className="close"
        aria-label="Close"
        onClick={(onCancel || onOk)}
        disabled={loading}
      >
        <span aria-hidden="true">×</span>
      </button>
      <div className="custom-modal-body" style={{'width': width || 'unset'}}>
        {children ? (
          children
        ) : (
          <>
            <div className="custom-modal-content">
              <h5 className="custom-modal-message text-center">{message}</h5>
              <div className="custom-modal-description text-center">
                {description}
              </div>
            </div>
            <div className="custom-modal-action">
              {onOk && (
                <button
                  className="btn btn-warning"
                  type="submit"
                  onClick={onOk}
                  disabled={loading}
                >
                  {textOk}
                </button>
              )}

              {onCancel && (
                <button
                  className="btn btn-secondary"
                  type="submit"
                  onClick={onCancel}
                  disabled={loading}
                >
                  {textCancel}
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </ReactModal>
  );
};

export default ModalError;
